import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import ReactGA from 'react-ga';

import './reset.scss';

import FieldGroupComponent from '../../../components/core/FieldGroupComponent/FieldGroupComponent';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';

class ResetPasswordComponent extends React.Component {
    componentDidMount() {
        const { isLoading, setLoading } = this.props;

        if (isLoading) {
            setLoading(false);
        }
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Reset Password Page' });
        ReactGA.pageview(window.location.pathname);
    }

    handleSubmit = () => {
        ReactGA.event({
            category: 'Reset Password Component',
            action: 'Clicked Reset Password',
            label: 'Button',
        });
    }

    onCancel = () => {
        const { onCancel } = this.props;
        ReactGA.event({
            category: 'Reset Password Component',
            action: 'Clicked Cancel',
            label: 'Button',
        });
        onCancel();
    }

    render() {
        const { handleSubmit, isLoading } = this.props;

        return <div className="reset-password container">
            {isLoading && <LoadingComponent fullScreen />}
            <h2>Reset Password</h2>
            <Form onSubmit={handleSubmit}>
                <FieldGroupComponent
                    label="Email"
                    name="email"
                    type="text"
                    placeholder="Enter Email"
                    formProps={{
                        maxLength: 100,
                    }}
                />
                <div className="buttons">
                    <Button type="submit" onClick={this.handleSubmit}>Reset Password</Button>
                    <Button className="dark" onClick={this.onCancel}>Cancel</Button>
                </div>
            </Form>
        </div>;
    }
}

ResetPasswordComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
};

export default ResetPasswordComponent;



// WEBPACK FOOTER //
// ./src/components/login/resetPassword/ResetPasswordComponent.js